import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { ReportInfo, ReportRecord } from '../../../models/report.model';
import deepmerge from 'deepmerge';

@Component({
  selector: 'rep-data-view-toolbar',
  templateUrl: './data-view-toolbar.component.html',
  styleUrls: ['./data-view-toolbar.component.scss'],
  standalone: false,
})
export class DataViewToolbarComponent implements OnChanges, OnInit, OnDestroy {
  draggedRowIndex: number;
  reportRecordData: ReportRecord[];

  @Input() reportData: ReportInfo;
  @Input() isUKFeaturesEnabled: boolean;

  @Output() customizeColumns: EventEmitter<string> = new EventEmitter<string>();
  @Output() reportReordered: EventEmitter<ReportRecord[]> = new EventEmitter<ReportRecord[]>();

  ngOnChanges({ reportData }: SimpleChanges) {
    if (!!reportData && !!reportData.currentValue) {
      this.reportRecordData = deepmerge([], this.reportData ? this.reportData.records : null);
    }
  }

  ngOnInit(): void {
    // required by angular-l10n
  }

  ngOnDestroy(): void {
    // required by angular-l10n
  }
}
